module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Target":"Ziel","Select a menu item ...":"Menüpunkt auswählen ...","Find a post ...":"Beitrag suchen ...","Email":"E-Mail","Phone number":"Telefon","Internal":"Intern","Menu item":"Menüpunkt","External":"Externe URL","Post":"Beitrag","Phone":"Telefon","Download":"Download","Anchor":"Anker","Open link in new window/tab":"Link in einem neuen Fenster/Tab öffnen"}}')
  delete Component.options._Ctor
}
